import {
  MembershipRead,
  useMembersListQuery,
} from 'src/common/external/bambi-api/bambiApi';

export function useNonDriverMembers(search?: string) {
  const queryState = useMembersListQuery({
    isDriver: false,
    isBambiStaff: false,
    search,
  });

  const members: MembershipRead[] = queryState.data?.results || [];

  return {
    members,
    queryState,
  };
}
